'use strict';

module.exports = function() {
	this.getDimensions();
	this.canvas.setAttribute('width', this.x1);
	this.canvas.setAttribute('height', this.y1);
	this.refreshColors();
};



//////////////////
// WEBPACK FOOTER
// ./~/granim/lib/onResize.js
// module id = 21
// module chunks = 0